// The red/white/blue tri-stripe header reused across every screen.
function AppHeader({ subtitle, topRight, middleItems = [], bottomLeft, bottomRight }) {
  return (
    <div className="headband">
      <div className="stripe-red">
        <div className="game-title">RPS Champ</div>
        {subtitle && <div className="headband-subtitle">{subtitle}</div>}
        {topRight}
      </div>
      <div className="stripe-white">
        {middleItems.map((item, index) => (
          <div className="white-label" key={index}>
            {item}
          </div>
        ))}
      </div>
      <div className="stripe-blue">
        <div className="blue-label">{bottomLeft}</div>
        {bottomRight}
      </div>
    </div>
  );
}

export default AppHeader;
